import React from 'react';

// Importing icons to match the card style
import ArchiveIcon from '@material-ui/icons/Archive';
import WarningIcon from '@material-ui/icons/Warning';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

// --- Data Constants ---

const SUMMARY_METRICS = [
    { label: 'Inventory', value: '28 days', delta: '-4 days opportunity', tone: 'blue', icon: <ArchiveIcon />, deltaTone: 'good' },
    { label: 'Excess Inventory', value: '₹42 Cr', delta: 'across markets', tone: 'purple', icon: <WarningIcon />, deltaTone: 'warn' },
    { label: 'Cash Release', value: '₹50 Cr', delta: 'illustrative potential', tone: 'green', icon: <AttachMoneyIcon />, deltaTone: 'good' },
    { label: 'Service', value: '98.8%', delta: 'after optimization', tone: 'orange', icon: <CheckCircleIcon />, deltaTone: 'good' },
];

const OPPORTUNITY_DATA = [
    { lever: 'FG inventory', current: '28 days', optimized: '24 days', cash: '+₹18 Cr', service: 'Neutral / +' },
    { lever: 'Market imbalance', current: '₹42 Cr', optimized: '₹24 Cr', cash: '+₹18 Cr', service: '+2.4 pp' },
    { lever: 'Production excess', current: '5 SKUs', optimized: '2 SKUs', cash: '+₹6 Cr', service: 'Neutral' },
    { lever: 'Packaging cover', current: 'High', optimized: 'Targeted', cash: '+₹5 Cr', service: 'Neutral' },
    { lever: 'Deployment cycle', current: 'Weekly', optimized: 'Demand-led', cash: '+₹3 Cr', service: '+1.1 pp' },
];

const LEVER_DATA = [
    { label: 'Inventory', percentage: 88, color: '#22c55e' },   // Green
    { label: 'Deployment', percentage: 74, color: '#22c55e' },  // Green
    { label: 'Production', percentage: 52, color: '#3b82f6' },  // Blue
    { label: 'Packaging', percentage: 46, color: '#f59e0b' },   // Orange
    { label: 'Logistics', percentage: 32, color: '#f59e0b' },   // Orange
];

export class Finance extends React.Component {
    render() {
        return (
            <div className="cc-page">
                {/* Header */}
                <div className="cc-header">
                    <div className="cc-header-text">
                        <h1>Working Capital & Cash Optimizer</h1>
                        <p>Convert supply-chain decisions into lower inventory, better cash conversion and protected service.</p>
                    </div>
                    <div className="cc-header-filters">
                        <button className="cc-filter-btn">Next 8 Weeks</button>
                        <button className="cc-filter-btn">All States</button>
                        <button className="cc-filter-btn">All Brands</button>
                    </div>
                </div>

                {/* Top Metrics Row - Updated to match the card style */}
                <div className="cc-metric-row">
                    {SUMMARY_METRICS.map((metric) => (
                        <div className={`cc-metric-card tone-${metric.tone}`} key={metric.label}>
                            <div className="cc-metric-icon-wrap">{metric.icon}</div>
                            <div className="cc-metric-content">
                                <div className="cc-metric-label">{metric.label}</div>
                                <div className="cc-metric-value">{metric.value}</div>
                                <div className={`cc-metric-delta cc-delta-${metric.deltaTone}`}>
                                    {metric.delta}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Main Content Row */}
                <div className="cc-main-row">
                    {/* Left Panel: Inventory-to-Cash Opportunity */}
                    <div className="cc-panel cc-panel-table">
                        <h2>Inventory-to-Cash Opportunity</h2>
                        
                        <table className="cc-actions-table cc-table-striped cc-table-light">
                            <thead>
                                <tr>
                                    <th>Lever</th>
                                    <th>Current</th>
                                    <th>Optimized</th>
                                    <th>Cash Impact</th>
                                    <th>Service Impact</th>
                                </tr>
                            </thead>
                            <tbody>
                                {OPPORTUNITY_DATA.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.lever}</td>
                                        <td>{row.current}</td>
                                        <td>{row.optimized}</td>
                                        <td className="cc-delta-good">{row.cash}</td>
                                        <td>{row.service}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Right Panel: Cash Actions by Lever */}
                    <div className="cc-panel">
                        <h2>Cash Actions by Lever</h2>
                        
                        {/* Horizontal Bar Charts */}
                        <div className="cc-bar-chart-container" style={{marginTop: '20px'}}>
                            {LEVER_DATA.map((bar) => (
                                <div className="cc-bar-row" key={bar.label}>
                                    <div className="cc-bar-label">{bar.label}</div>
                                    <div className="cc-bar-track">
                                        <div 
                                            className="cc-bar-fill" 
                                            style={{ width: `${bar.percentage}%`, backgroundColor: bar.color }}
                                        ></div>
                                    </div>
                                    <div className="cc-bar-percent" style={{ color: bar.color }}>
                                        {bar.percentage}%
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* North Star Text */}
                        <div className="cc-north-star">
                            <p><strong>North Star:</strong></p>
                            <p>Protect service while releasing cash trapped in the demand-to-supply cycle.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Finance;